(function($, undefined) {
	'use strict';
	var utils;
	var toast;

	var init = function() {
		utils = Fw.component.models().utils;
		toast = Fw.component.models().toast;

		$('.save-component-custom-id-btn').on('click', onSaveCustomComponentIdBtnClick);
		$('.copy-anchor-btn').on('click', onCopyAnchorBtnClick);
	};

	function onSaveCustomComponentIdBtnClick() {
		var btn = $(this);
		var ctn = btn.closest('.stool-component-settings-popup');
		var input = $('[name^=custom-component-id-]', ctn);
		var key = btn.attr("data-key");
		var successMsg = $('.form-message_success', ctn);
		var textId = btn.attr("data-text-id");

		var valueToSave = getAnchorValue(ctn);

		updateLabel(key, valueToSave, $("html").attr("lang"), () => {
			successMsg.slideDown(300);
			setTimeout(() => {
				successMsg.slideUp(300);
			}, 3000);

			if (valueToSave.length === 0) {
				$('[name^=custom-component-id-]', ctn).val(btn.attr("data-default-id"));
			} else {
				$('[name^=custom-component-id-]', ctn).val(valueToSave);
			}
			
		}, true);
	}

	function getAnchorValue(ctn) {
		var btn = $('.save-component-custom-id-btn', ctn);
		var value = $('[name^=custom-component-id-]', ctn).val();
		var textId = btn.attr("data-text-id");
		var isComponent = btn.attr("data-is-component") == "true";
		var isDefaultId = btn.attr("data-default-id") == value;
		var valueToSave = utils.slugify(value, true); // keep capital letters and underscores
		if (isComponent && valueToSave.length > 0 && !isDefaultId && valueToSave.indexOf("-" + textId) === -1) {
			valueToSave += "-" + textId;
		}
		return valueToSave;
	}

	function onCopyAnchorBtnClick() {
		var btn = $(this);
		var ctn = btn.closest('.stool-component-settings-popup');
		var input = $('[name^=custom-component-id-]', ctn)[0];
		var anchorValue = getAnchorValue(ctn);

		input.select();
		input.setSelectionRange(0, 99999); /*For mobile devices*/
		document.execCommand("copy");

		toast.create(
			(document.documentElement.lang === 'fr' ? "L'ancre a bien �t� copi�e dans votre presse-papier: " : "The anchor was copied to your clipboard: ") + anchorValue,
			toast.DURATION.SHORT,
			"success"
		);
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
